import * as Types from '../graphQlTypes.generated';

import { graphQlService } from '@doxyme/frontend/services/graphql.service';
export type StartArchiveMutationVariables = Types.Exact<{
  input: Types.StartArchiveInput;
}>;


export type StartArchiveMutation = { __typename?: 'Mutation', Transcription: { __typename?: 'TranscriptionMutations', startArchive: { __typename?: 'Transcription', id: string } } };

export type StopArchiveMutationVariables = Types.Exact<{
  input: Types.StopArchiveInput;
}>;


export type StopArchiveMutation = { __typename?: 'Mutation', Transcription: { __typename?: 'TranscriptionMutations', stopArchive: { __typename?: 'Transcription', id: string } } };

export type CancelArchiveMutationVariables = Types.Exact<{
  input: Types.CancelArchiveInput;
}>;


export type CancelArchiveMutation = { __typename?: 'Mutation', Transcription: { __typename?: 'TranscriptionMutations', cancelArchive: { __typename?: 'Transcription', id: string } } };

export type DeleteTranscriptMutationVariables = Types.Exact<{
  input: Types.DeleteTranscriptInput;
}>;


export type DeleteTranscriptMutation = { __typename?: 'Mutation', Transcription: { __typename?: 'TranscriptionMutations', deleteTranscript: boolean } };


export const StartArchiveDocument = `
    mutation startArchive($input: StartArchiveInput!) {
  Transcription {
    startArchive(input: $input) {
      id
    }
  }
}
    `;
export const StopArchiveDocument = `
    mutation stopArchive($input: StopArchiveInput!) {
  Transcription {
    stopArchive(input: $input) {
      id
    }
  }
}
    `;
export const CancelArchiveDocument = `
    mutation cancelArchive($input: CancelArchiveInput!) {
  Transcription {
    cancelArchive(input: $input) {
      id
    }
  }
}
    `;
export const DeleteTranscriptDocument = `
    mutation deleteTranscript($input: DeleteTranscriptInput!) {
  Transcription {
    deleteTranscript(input: $input)
  }
}
    `;

const injectedRtkApi = graphQlService.injectEndpoints({
  endpoints: (build) => ({
    startArchive: build.mutation<StartArchiveMutation, StartArchiveMutationVariables>({
      query: (variables) => ({ document: StartArchiveDocument, variables })
    }),
    stopArchive: build.mutation<StopArchiveMutation, StopArchiveMutationVariables>({
      query: (variables) => ({ document: StopArchiveDocument, variables })
    }),
    cancelArchive: build.mutation<CancelArchiveMutation, CancelArchiveMutationVariables>({
      query: (variables) => ({ document: CancelArchiveDocument, variables })
    }),
    deleteTranscript: build.mutation<DeleteTranscriptMutation, DeleteTranscriptMutationVariables>({
      query: (variables) => ({ document: DeleteTranscriptDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useStartArchiveMutation, useStopArchiveMutation, useCancelArchiveMutation, useDeleteTranscriptMutation } = injectedRtkApi;

